import apis from "../../core/apis.js";

class CountryResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.country).get(options);
  }

  getAllActive(options) {
    return this.$resource(apis.country + "active", null, {
      get: { isArray: true },
    }).get(options);
  }

  get(id) {
    return this.$resource(apis.country + id).get();
  }

  search(query = "") {
    return this.$resource(apis.country + "autocomplete/").get({ query });
  }

  post(item) {
    return this.$resource(apis.country).save(item);
  }

  update(id, item) {
    return this.$resource(apis.country + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
  updateFeatureFlags(id, item) {
    return this.$resource(apis.country + id + "/feature-flags", null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default CountryResource;



// WEBPACK FOOTER //
// ./src/resources/country/country.resource.js